import FinancialInstitutionLayout from "./FinancialInstitutionLayout";
import FinancialInstitutionListPage from "./pages/FinancialInstitutionListPage";
import FinancialInstitutionCreatePage from "./pages/FinancialInstitutionCreatePage";
import FinancialInstitutionDetailPage from "./pages/FinancialInstitutionDetailPage";

export const financialInstitutionRoutes = {
  path: "financial-institution",
  component: FinancialInstitutionLayout,
  children: [
    {
      name: "FinancialInstitutionListPage",
      component: FinancialInstitutionListPage,
      path: ""
    },
    {
      name: "FinancialInstitutionCreatePage",
      component: FinancialInstitutionCreatePage,
      path: "create"
    },
    {
      name: "FinancialInstitutionDetailPage",
      component: FinancialInstitutionDetailPage,
      path: ":id"
    }
  ]
}


// WEBPACK FOOTER //
// ./src/features/financial-institutions/routes.js